<template>
  <b-card-body>
    <template v-if="!choose_phone_number">
      <b-card-title>WhatsApp Business API</b-card-title>
      <b-card-sub-title>WhatsApp is one of the most popular communication applications in the world. WhatsApp is a Facebook company and requires a Facebook account and Facebook Business Manager to set up.</b-card-sub-title>
      <el-divider/>
      <b-card-sub-title class="font-weight-bold">Before you start, you'll need:</b-card-sub-title>
      <ol>
        <li>Access to Facebook Business Manager</li>
        <li>A viable Phone Number for WhatsApp</li>
        <li>Your business legal address and details</li>
        <li>Select the numbers you want to connect</li>
        <li>Verify your Facebook Business</li>
      </ol>
      <b-card-sub-title>Did you want to use your existing WhatsApp Business App phone number?</b-card-sub-title>
      <b-form-group>
        <b-form-radio-group v-model="useExistingWA" :options="hasExistingWA" buttons button-variant="outline-primary" />
      </b-form-group>
      <el-button v-if="useExistingWA" :loading="loading.embed_signup" @click="launchWhatsAppCoexSignup()" style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;">Get Started with WhatsApp Business App</el-button>
      <el-button v-if="!useExistingWA" :loading="loading.embed_signup" @click="launchWhatsAppSignup()" style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;">Get Started</el-button>
    </template>
    <template v-else>
      <b-card-title>Select Phone Number</b-card-title>
      <b-card-sub-title>Please select one of phone number below to be added to this workspace.</b-card-sub-title>
      <div v-for="(bus, index1) in phone_number_list" :key="index1">
        <p class="mb-2"><strong>{{ bus.business.name }}</strong><br>WABA ID {{ bus.business.id }}</p>
        <el-radio-group v-model="configuration.phone_number_id">
          <el-radio-button v-for="(phone, index2) in bus.phone_numbers" :key="index2" :label="phone.id" border>
            <span><country-flag :country="getCountryCode(phone.display_phone_number)" size='small'/>&nbsp;{{ phone.display_phone_number }}</span>
          </el-radio-button>
        </el-radio-group>
        <el-divider/>
      </div>
      <b-button @click="createChannel" variant="primary">{{ $t('general.submit') }}</b-button>
    </template>
  </b-card-body>
</template>
<script>
import { AsYouType } from 'libphonenumber-js';
import CountryFlag from 'vue-country-flag';
import channelsAPI from '../../../api/channels';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  components: {
    CountryFlag,
  },
  name: 'AddWhatsappChannel',
  data() {
    return {
      provider: 'client_premise',
      hasRegisteredAccount: null,
      useExistingWA: false,
      whatsappProvider: [
        // { text: 'Makna.ai', value: 'makna' },
        // { text: 'DAMCorp', value: 'damcorp' },
        { text: 'On Premise', value: 'client_premise' },
        { text: 'Cloud API', value: 'cloud_api_wa' },
      ],
      hasRegistered: [
        { text: 'Yes, I have one', value: true },
        { text: 'No', value: false },
      ],
      hasExistingWA: [
        { text: 'Yes, use my existing WhatsApp Business account', value: true },
        { text: 'No, use another phone number', value: false },
      ],
      configuration: {
        username: 'admin',
        password: '',
        base_url: '',
        token: '',
        business_id: '',
        phone_number_id: '',
        sender: '',
      },
      loading: {
        embed_signup: false,
      },
      choose_phone_number: false,
      phone_number_list: [],
    };
  },
  async mounted() {
    window.addEventListener('message', async (event) => {
      if (event.origin !== 'https://www.facebook.com' && event.origin !== 'https://web.facebook.com') return;
      try {
        const data = JSON.parse(event.data);
        console.log('message event: ', data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          const { data: response_data } = await channelsAPI.getEmbedPhoneNumber(data.data.waba_id);
          this.phone_number_list = response_data.list;
          this.choose_phone_number = true;
          this.provider = 'cloud_api_embed';
        }
      } catch (error) {
        console.log(error);
        // console.log('message event: ', event.data);
      }
    });
  },
  methods: {
    getCountryCode(input) {
      const asYouType = new AsYouType();
      asYouType.input(input);
      return asYouType.getNumber().country.toLowerCase();
    },
    createChannel() {
      if (this.provider === 'cloud_api_embed') {
        const obj = this.phone_number_list.find((v) => {
          const o = v.phone_numbers.find((p) => p.id === this.configuration.phone_number_id);
          if (!o) {
            return false;
          }
          return v;
        });
        if (!obj) {
          return;
        }
        this.configuration.use_whatsapp_coex = this.useExistingWA;
        this.configuration.business_id = obj.business.id;
      }
      if (this.configuration.sender) {
        this.configuration.sender = this.configuration.sender.replace(/\D/ig, '');
      }
      this.$emit('createChannel', this.configuration, this.provider);
    },
    /* eslint-disable no-undef */
    async launchWhatsAppCoexSignup() {
      try {
        this.loading.embed_signup = true;
        FB.login((response) => {
          console.log(response);
        }, {
          config_id: process.env.VUE_APP_EMBED_SIGNUP_CONFIG_ID,
          response_type: 'code',
          scope: 'whatsapp_business_management,whatsapp_business_messaging',
          override_default_response_type: true,
          extras: {
            featureType: 'whatsapp_business_app_onboarding',
            setup: {},
            sessionInfoVersion: '3',
          },
        });
      } catch (error) {
        console.log(error);
        this.loading.embed_signup = false;
      }
    },
    /* eslint-disable no-undef */
    async launchWhatsAppSignup() {
      try {
        this.loading.embed_signup = true;
        FB.login((response) => {
          // console.log(JSON.stringify(response));
          if (response.authResponse) {
            // Use this token to call the debug_token API and get the shared WABA's ID
            const { accessToken, code } = response.authResponse;
            channelsAPI.initLinkAge({
              token: accessToken,
              code,
            }).then(async (response1) => {
              await popupErrorMessages(response1);
              const { data } = await channelsAPI.getEmbedPhoneNumber();
              this.phone_number_list = data.list;
              this.choose_phone_number = true;
              this.provider = 'cloud_api_embed';
            });
          } else {
            console.log('User cancelled login or did not fully authorize.', response);
          }
          this.loading.embed_signup = false;
        }, {
          config_id: process.env.VUE_APP_EMBED_SIGNUP_CONFIG_ID,
          response_type: 'code',
          scope: 'whatsapp_business_management,whatsapp_business_messaging',
          override_default_response_type: true,
          extras: {
            featureType: this.$route.query.featureType || 'whatsapp_embedded_signup',
            setup: {},
            sessionInfoVersion: '3',
          },
        });
      } catch (error) {
        console.log(error);
        this.loading.embed_signup = false;
      }
    },
  },
};
</script>
